import React from 'react';
// import BtnFormat from "../Common/BtnFormat";
import './style/notifiVisitor.css'
import moment from "moment";

function NotifiVisitor(props) {
    return (
        <div className={`notifi_vistor_bx  ${props.setClass}`}>
            <div className="popup_close" style={{ color: '#000', position: 'absolute', top: '8px', right: '15px', cursor: 'pointer', backgroundColor: 'transparent', border: '0px', borderRadius: '0px'}} onClick={() => props.onHide(false)}>
                <i className="fa fa-times" style={{marginLeft: '4px'}}></i>  
            </div>
            <div className="notifi_vistor_body">
                <div className="notifi_vistor_left_content">
                    <div className="notifi_vistor_content_icon">
                        <img src={process.env.PUBLIC_URL + "/images/refresh_icon.svg"} style={{width: "30px", paddingTop: "3px"}} />
                    </div>
                    <div className="notifi_vistor_content_msg">
                        <h6>Your next appointment starts in 5 mins.</h6>
                        <p>
                            <span className="vistor_msg_text">
                                Your ongoing consultion is overlapped with the next appointment booked at
                            </span> {' '}
                            <span className="vistor_msg_timing">
                                <span>{moment(props.time,"DD-MM-YYYY hh:mm:ssZ").format("hh:mm A")}</span> with
                                <span>{' '}{props.patientName}</span>
                            </span>
                        </p>
                    </div>
                </div>
                <div className="notifi_vistor_right_content">
                    <button className="btn_format isActive" onClick={()=> {props.instantRescheduleAppointmentNotifi()}} >Reschedule Appointment</button>
                    <button className="btn_format noActive" onClick={()=> {props.instantCancelAppointment()}}>Cancel Appointment</button>
                    {/* <BtnFormat title="Reschedule Appointment" style="isActive" onClick={props.yesRescheduleHandler}/>
                    <BtnFormat title="Cancel Appointment" style="noActive" /> */}
                </div>
            </div>
        </div>
    );
}

export default NotifiVisitor;